import api from "!../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/esbuild-loader/dist/index.js??clonedRuleSet-4.use[2]!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./list-summary.vue?vue&type=style&index=0&id=52d4ad5b&lang=css";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};